import React, { useContext, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { CartContext } from "./CartContext";
import siteConfig from "../Datas/siteConfig";
import "../css/paysuccess.css";

const PaymentResult = () => {
  const location = useLocation();
  const { clearCart } = useContext(CartContext);
  const params = new URLSearchParams(location.search);
  const paymentState = params.get("state") === "success" ? "success" : "cancel";
  const orderNumber = params.get("orderNo") || location.state?.orderNumber;

  useEffect(() => {
    if (paymentState === "success") clearCart();
  }, [paymentState, clearCart]);

  const success = paymentState === "success";
  return (
    <main className="payment-success" id="main-content">
      <section className="payment-success__card" role="status" aria-labelledby="payment-result-title">
        <div className="payment-success__mark" aria-hidden="true">
          {success ? (
            <svg viewBox="0 0 64 64" focusable="false"><path d="M17 33.5 27.5 44 48 21.5" /></svg>
          ) : (
            <svg viewBox="0 0 64 64" focusable="false"><path d="M20 20 44 44M44 20 20 44" /></svg>
          )}
        </div>
        <p className="payment-success__eyebrow">{success ? "Payment successful" : "Payment not completed"}</p>
        <h1 id="payment-result-title">{success ? "Thank you — your order is confirmed" : "Your order is still waiting"}</h1>
        <p className="payment-success__lead">
          {success
            ? "Your payment was accepted. We will send order updates to the email supplied at checkout."
            : "The payment was cancelled or did not complete. Your bag has been kept so you can safely try again."}
        </p>
        {orderNumber && <dl className="payment-success__details"><div><dt>Order reference</dt><dd>{orderNumber}</dd></div></dl>}
        <div className="payment-success__actions">
          <Link to={success ? "/shop" : "/checkout"}>{success ? "Continue exploring" : "Return to checkout"}</Link>
          <Link to="/">Return home</Link>
        </div>
        <p className="payment-success__support">Need help? Email <a href={`mailto:${siteConfig.contact.customerServiceEmail}`}>{siteConfig.contact.customerServiceEmail}</a>.</p>
      </section>
    </main>
  );
};

export default PaymentResult;
